import { MediaCardProps } from "../components/MediaCard/MediaCard";

export const mediaCards: MediaCardProps[] = [
  {
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Showroom entrance with a living room display",
    badgeLabel: "Launch 4",
    title: "SE01: Showroom entrance — TERRSJÖ/TONSTAD",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Published",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Living room display with storage furniture",
    badgeLabel: "Launch 4",
    title: "L00: Living room — SALTMYRAN/KALLAX",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Unpublished",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom display with RÅDMANSÖ furniture",
    badgeLabel: "Launch 4",
    title: "B05: Bedroom — RÅDMANSÖ",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Published",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen display with ASPUDDEN furniture",
    badgeLabel: "Launch 4",
    title: "KV00: Kitchen — ASPUDDEN",
    fiscalYear: "FY26",
    mediaType: "Vignette",
    status: "Published",
  },
  {
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Staircase entrance display with MÅBÄRSSKÄR products",
    badgeLabel: "Launch 4",
    title: "Staircase entrance — MÅBÄRSSKÄR",
    fiscalYear: "FY26",
    mediaType: "Statement media",
    status: "Published",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Dining room display with neutral wood and textile styling",
    badgeLabel: "Launch 4",
    title: "D01: Dining room — TOSTERÖD",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Published",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Storage wall with acoustic and shelving styling",
    badgeLabel: "Launch 4",
    title: "L12: Storage wall — BILLY/HEMNES",
    fiscalYear: "FY26",
    mediaType: "Vignette",
    status: "Unpublished",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom styling with layered textiles and lighting",
    badgeLabel: "Launch 4",
    title: "B12: Bedroom — HEMNES",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Published",
  },
  {
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen island scenario with countertop accessories",
    badgeLabel: "Launch 4",
    title: "KV07: Kitchen — KNOXHULT",
    fiscalYear: "FY26",
    mediaType: "Statement media",
    status: "Published",
  },
  {
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Entryway with storage and decor accessory styling",
    badgeLabel: "Launch 4",
    title: "Entryway — STOCKHOLM/VOXLA",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    status: "Published",
  },
];
